import React, { useState } from 'react';
import styled from 'styled-components';
import uuid from 'uuid';

import { Body1, H3 } from 'components/atoms/Text';
import { InputWithBorder } from 'components/molecules/TextInput';
import { CourseSetUpContainer, HeaderContainer, InvitedUserTable, UploadCSV } from 'components/organisms/CourseSetUp';
import { message } from 'shell/components';
import { emailRegex } from 'utils/constants';

const StyledLink = styled.span`
    color: #6347ff;
    text-decoration: underline;

    &:hover {
        cursor: pointer;
    }
`;

const UploadCSVButtonContainer = styled.div`
    width: 100%;
    display: ${(props) => (props.review ? 'none' : 'flex')};
    justify-content: center;
    margin: 30px 0px 0px 0px;
`;

const StudentListContainer = styled.div`
    margin-top: 1em;
`;

const InviteStudents = ({ fieldKeys, courseData = {}, review = false, downloadTemplate, handleInputChange }) => {
    const [newUser, setNewUser] = useState();

    const handleKeyDown = (e) => {
        if (e.key !== 'Enter') return;
        if (courseData[fieldKeys?.STUDENT_LIST]?.some((student) => student.email === newUser))
            return message.error('The email already exists.');
        if (courseData[fieldKeys?.STAFF_LIST].some((staff) => staff.email === newUser))
            return message.error('The email already exists in the list of staff.');
        if (!emailRegex.test(newUser)) return message.error('Please enter a valid email.');
        const newStudentList = [
            ...(courseData[fieldKeys?.STUDENT_LIST] || []),
            { id: uuid.v4(), email: newUser?.trim() },
        ];
        handleInputChange(fieldKeys?.STUDENT_LIST, newStudentList);
        return setNewUser('');
    };

    return (
        <CourseSetUpContainer>
            <HeaderContainer review={review}>
                <H3>Invite Students</H3>
                <Body1 style={{ marginBottom: 25 }}>
                    Input or upload a CSV (
                    <StyledLink onClick={() => downloadTemplate('student')}>download here</StyledLink>) with the list of
                    emails of the students which you would like to forward a link to access this course.
                </Body1>
            </HeaderContainer>
            <UploadCSVButtonContainer review={review}>
                <UploadCSV
                    onRequest={(data) => handleInputChange(fieldKeys?.STUDENT_LIST, data)}
                    userData={courseData[fieldKeys?.STUDENT_LIST]}
                />
            </UploadCSVButtonContainer>
            <InputWithBorder
                error={false}
                errorMessage=''
                placeholder='e.g. john@ensightful.com'
                required={false}
                title='Invite By Email'
                value={newUser}
                onChange={(value) => setNewUser(value)}
                onKeyDown={(e) => handleKeyDown(e)}
            />
            <StudentListContainer>
                <InvitedUserTable
                    type={fieldKeys?.STUDENT_LIST}
                    tableType={'student'}
                    userList={courseData[fieldKeys?.STUDENT_LIST]}
                    handleInputChange={handleInputChange}
                    review={review}
                    isWithTeam={false}
                />
            </StudentListContainer>
        </CourseSetUpContainer>
    );
};

export default InviteStudents;
